import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DescriptionDetailedItem } from './description-detailed-item.component';

export interface DescriptionDetailedCategory {
    title: DescriptionDetailedItem;
    items: DescriptionDetailedItem[];
    has_bullet: boolean;
}

@Component({
    selector: 'description-detailed-category',
    template: `
        <description-detailed-item *ngIf="category.title" class="category-title" [item]="category.title"></description-detailed-item>
        
        <ul *ngIf="category.items && category.items.length > 0" class="description-detailed-items"
            [ngClass]="{'has-bullet': category.has_bullet || hasBullet}">
            <li *ngFor="let item of category.items">
                <description-detailed-item [item]="item"></description-detailed-item>
            </li>
        </ul>
    `,
    styleUrls: ['./description-detailed.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DescriptionDetailedCategoryComponent {
    @Input() category: DescriptionDetailedCategory;
    @Input() hasBullet: boolean;

    constructor() { }
}